// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yX_g5ubr7VcpP0nQyzH9 {
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 1023px) {
  .yX_g5ubr7VcpP0nQyzH9 {
    top: 24px;
    left: 24px;
    right: 24px;
  }
}
@media only screen and (max-width: 767px) {
  .yX_g5ubr7VcpP0nQyzH9 {
    top: 24px;
    left: 16px;
    right: 16px;
  }
}
@media only screen and (max-width: 1023px) {
  .yX_g5ubr7VcpP0nQyzH9.Z1TQRv4Gv8lSLwyTQPRC {
    flex-wrap: wrap;
  }
  .yX_g5ubr7VcpP0nQyzH9.Z1TQRv4Gv8lSLwyTQPRC .wI83vb93Bh2Adc1wg97t {
    order: 1;
    position: static;
    flex-grow: 1;
    max-width: calc(100% - 96px);
    padding-right: 24px;
    transform: translate(0, 0);
    text-align: left;
  }
  .yX_g5ubr7VcpP0nQyzH9.Z1TQRv4Gv8lSLwyTQPRC ._RFHc7oFkndMP9CJQj0k {
    order: 2;
    align-self: flex-start;
  }
  .yX_g5ubr7VcpP0nQyzH9.Z1TQRv4Gv8lSLwyTQPRC .mTRLRwFunvayss47YCox {
    order: 3;
    width: 100%;
    margin-top: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .yX_g5ubr7VcpP0nQyzH9.Z1TQRv4Gv8lSLwyTQPRC .wI83vb93Bh2Adc1wg97t {
    padding: 0 16px 0 0;
  }
}

.mTRLRwFunvayss47YCox {
  display: flex;
  align-items: center;
  margin-right: auto;
  flex-shrink: 0;
}
.mTRLRwFunvayss47YCox .bGPKUNOOryEKR1Epjh7O {
  margin-left: 12px;
}

.C4IVniKXIkVzRU6oEC7b {
  height: 40px;
  padding: 0 16px;
  background: #EFEFEF;
  border: 1px solid #FCFCFC;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.8461538462;
  color: #1A1D1F;
  transition: all 0.2s;
}
@media only screen and (max-width: 767px) {
  .C4IVniKXIkVzRU6oEC7b {
    width: 40px;
    padding: 0;
    border-radius: 50%;
    font-size: 0;
  }
}
.dark-mode .C4IVniKXIkVzRU6oEC7b {
  background: transparent;
  border-color: #EFEFEF;
}

.C4IVniKXIkVzRU6oEC7b svg {
  margin-right: 10px;
  fill: #FF6A55;
  transition: fill 0.2s;
}
@media only screen and (max-width: 767px) {
  .C4IVniKXIkVzRU6oEC7b svg {
    margin-right: 0;
  }
}
.C4IVniKXIkVzRU6oEC7b:hover {
  border-color: #FF6A55;
  background: #FF6A55;
  color: #FCFCFC;
}
.C4IVniKXIkVzRU6oEC7b:hover svg {
  fill: #FCFCFC;
}

.wI83vb93Bh2Adc1wg97t {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 550px;
  text-align: center;
  font-size: 20px;
  flex-wrap: 600;
  line-height: 1.2;
  color: #FCFCFC;
}
@media only screen and (max-width: 1259px) {
  .wI83vb93Bh2Adc1wg97t {
    max-width: 360px;
  }
}
@media only screen and (max-width: 767px) {
  .wI83vb93Bh2Adc1wg97t {
    position: static;
    flex-grow: 1;
    max-width: 100%;
    padding: 0 16px;
    transform: translate(0, 0);
    font-size: 15px;
  }
}
.dark-mode .wI83vb93Bh2Adc1wg97t {
  color: #1A1D1F;
}

._RFHc7oFkndMP9CJQj0k {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.R9KMEE9MUE1sIFGliWe0 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #FFFFFF;
  font-size: 0;
}
.R9KMEE9MUE1sIFGliWe0 svg {
  fill: #33383F;
  transition: transform 0.2s;
}
.dark-mode .R9KMEE9MUE1sIFGliWe0 {
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06);
}

.R9KMEE9MUE1sIFGliWe0:hover svg {
  transform: rotate(90deg);
}

.GD5ACHjFxZ36qi3zQYid {
  width: 40px;
  height: 40px;
  margin-right: 16px;
  border-radius: 50%;
  border: 2px solid #272B30;
  font-size: 0;
  transition: background 0.2s;
}
.GD5ACHjFxZ36qi3zQYid svg {
  fill: #6F767E;
  transition: fill 0.2s;
}
.GD5ACHjFxZ36qi3zQYid:hover {
  background: #272B30;
}
.GD5ACHjFxZ36qi3zQYid:hover svg {
  fill: #FCFCFC;
}
.dark-mode .GD5ACHjFxZ36qi3zQYid {
  border-color: #EFEFEF;
}
.dark-mode .GD5ACHjFxZ36qi3zQYid:hover {
  background: #EFEFEF;
}
.dark-mode .GD5ACHjFxZ36qi3zQYid:hover svg {
  fill: #1A1D1F;
}`, "",{"version":3,"sources":["webpack://./src/components/ModalPreview/Panel/Panel.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AADF;ACMI;EDXJ;IAQI,SAAA;IACA,UAAA;IACA,WAAA;EACF;AACF;ACEI;EDdJ;IAYI,SAAA;IACA,UAAA;IACA,WAAA;EAIF;AACF;ACRI;EDIF;IAEI,eAAA;EAMJ;EALI;IACE,QAAA;IACA,gBAAA;IACA,YAAA;IACA,4BAAA;IACA,mBAAA;IACA,0BAAA;IACA,gBAAA;EAON;EANI;IACE,QAAA;IACA,sBAAA;EAQN;EAPI;IACE,QAAA;IACA,WAAA;IACA,gBAAA;EASN;AACF;AC5BI;EDoBE;IACE,mBAAA;EAWN;AACF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAaF;AAZE;EACE,iBAAA;AAcJ;;AAZA;EACE,YAAA;EACA,eAAA;EACA,mBCPG;EDQH,yBAAA;EACA,kBAAA;ECmFE,eAAA;EACA,gBAAA;EACA,yBAAA;EDnFF,cCPG;EDQH,oBAAA;AAiBF;ACxDI;ED+BJ;IAUI,WAAA;IACA,UAAA;IACA,kBAAA;IACA,YAAA;EAmBF;AACF;AC4Ga;ED9HT,uBAAA;EACA,qBCpBC;ADyCL;;AApBE;EACE,kBAAA;EACA,aClCC;EDmCD,qBAAA;AAuBJ;AC1EI;EDgDF;IAKI,eAAA;EAyBJ;AACF;AAzBE;EACE,qBCvCC;EDwCD,mBCxCC;EDyCD,cChCC;AD2DL;AA1BI;EACE,aClCD;AD8DL;;AA1BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cC9CG;AD2EL;AC1GI;EDmEJ;IAYI,gBAAA;EA+BF;AACF;ACzGI;ED6DJ;IAcI,gBAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;IACA,0BAAA;IACA,eAAA;EAkCF;AACF;ACyDa;ED1FT,cCnDC;ADuFL;;AAlCA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAqCF;;AAnCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBCrEE;EDsEF,YAAA;AAsCF;AArCE;EACE,aCnEC;EDoED,0BAAA;AAuCJ;ACoCa;EDzET,2CAAA;AAwCJ;;AAtCI;EACE,wBAAA;AAyCN;;AAvCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,2BAAA;AA0CF;AAzCE;EACE,aCrFC;EDsFD,qBAAA;AA2CJ;AA1CE;EACE,mBCtFC;ADkIL;AA3CI;EACE,aC7FD;AD0IL;ACSa;EDpDT,qBC7FC;AD2IL;AA7CI;EACE,mBC/FD;AD8IL;AA9CM;EACE,aC7FH;AD6IL","sourcesContent":["@import ../../../styles/helpers\n\n.panel\n  position: absolute\n  top: 40px\n  left: 40px\n  right: 40px\n  display: flex\n  align-items: center\n  +t\n    top: 24px\n    left: 24px\n    right: 24px\n  +m\n    top: 24px\n    left: 16px\n    right: 16px\n  &.panelGallery\n    +t\n      flex-wrap: wrap\n      .title\n        order: 1\n        position: static\n        flex-grow: 1\n        max-width: calc(100% - 96px)\n        padding-right: 24px\n        transform: translate(0,0)\n        text-align: left\n      .control\n        order: 2\n        align-self: flex-start\n      .actions\n        order: 3\n        width: 100%\n        margin-top: 20px\n    +m\n      .title\n        padding: 0 16px 0 0\n\n.actions\n  display: flex\n  align-items: center\n  margin-right: auto\n  flex-shrink: 0\n  .button\n    margin-left: 12px\n\n.favorite\n  height: 40px\n  padding: 0 16px\n  background: $n3\n  border: 1px solid $n1\n  border-radius: 8px\n  +button2\n  color: $n7\n  transition: all .2s\n  +m\n    width: 40px\n    padding: 0\n    border-radius: 50%\n    font-size: 0\n  +dark\n    background: transparent\n    border-color: $n3\n  svg\n    margin-right: 10px\n    fill: $p3\n    transition: fill .2s\n    +m\n      margin-right: 0\n  &:hover\n    border-color: $p3\n    background: $p3\n    color: $n1\n    svg\n      fill: $n1\n\n.title\n  position: absolute\n  top: 50%\n  left: 50%\n  transform: translate(-50%,-50%)\n  max-width: 550px\n  text-align: center\n  font-size: 20px\n  flex-wrap: 600\n  line-height: 1.2\n  color: $n1\n  +d\n    max-width: 360px\n  +m\n    position: static\n    flex-grow: 1\n    max-width: 100%\n    padding: 0 16px\n    transform: translate(0,0)\n    font-size: 15px\n  +dark\n    color: $n7\n\n.control\n  display: flex\n  align-items: center\n  flex-shrink: 0\n\n.close\n  width: 40px\n  height: 40px\n  border-radius: 50%\n  background: $n\n  font-size: 0\n  svg\n    fill: $n5\n    transition: transform .2s\n  +dark\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06)\n  &:hover\n    svg\n      transform: rotate(90deg)\n\n.link\n  width: 40px\n  height: 40px\n  margin-right: 16px\n  border-radius: 50%\n  border: 2px solid $n6\n  font-size: 0\n  transition: background .2s\n  svg\n    fill: $n4\n    transition: fill .2s\n  &:hover\n    background: $n6\n    svg\n      fill: $n1\n  +dark\n    border-color: $n3\n    &:hover\n      background: $n3\n      svg\n        fill: $n7","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `yX_g5ubr7VcpP0nQyzH9`,
	"panelGallery": `Z1TQRv4Gv8lSLwyTQPRC`,
	"title": `wI83vb93Bh2Adc1wg97t`,
	"control": `_RFHc7oFkndMP9CJQj0k`,
	"actions": `mTRLRwFunvayss47YCox`,
	"button": `bGPKUNOOryEKR1Epjh7O`,
	"favorite": `C4IVniKXIkVzRU6oEC7b`,
	"close": `R9KMEE9MUE1sIFGliWe0`,
	"link": `GD5ACHjFxZ36qi3zQYid`
};
export default ___CSS_LOADER_EXPORT___;
